"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSelectedOptions = void 0;
var _react = require("react");
var useSelectedOptions = exports.useSelectedOptions = function useSelectedOptions(_ref) {
  var options = _ref.options,
    value = _ref.value,
    getOptionValue = _ref.getOptionValue,
    multiple = _ref.multiple,
    hasEmptyOption = _ref.hasEmptyOption;
  return (0, _react.useMemo)(function () {
    var selectedOptions = [];
    options && options.forEach(function (option) {
      var selected = false;
      var optionValue = getOptionValue(option);
      if (multiple) {
        if (Array.isArray(value)) {
          selected = value.some(function (v) {
            return v === optionValue;
          });
        }
      } else {
        selected = value === optionValue;
        if (!selected && hasEmptyOption && ['', undefined, null].includes(value)) {
          selected = ['', undefined, null].includes(optionValue);
        }
      }
      if (selected) {
        selectedOptions.push(option);
      }
    });
    return selectedOptions;
  }, [options, value, multiple, getOptionValue, hasEmptyOption]);
};